// extracted by mini-css-extract-plugin
export var locationCard = "_fd-0";